import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "permissions-page" }
const _hoisted_2 = { class: "permissions-page__top" }
const _hoisted_3 = { class: "permissions-page__top-actions" }
const _hoisted_4 = { class: "permissions-page__dropdown-search" }
const _hoisted_5 = { class: "permissions-page__main" }
const _hoisted_6 = { class: "permissions-page__content" }

import { ref, computed, onMounted } from "vue";
import { Ref } from "vue";
import { Plus, Search } from "@element-plus/icons-vue";
import { useStore } from "vuex";
import { ElMessageBox } from "element-plus";
import { EmptyData } from "@/shared/ui/components/EmptyData";
import { IUser } from "@/shared/types/permissions";


export default /*@__PURE__*/_defineComponent({
  __name: 'PermissionsPage',
  setup(__props) {

const store = useStore();
const searchQuery = ref("");
const searchDropdownQuery = ref("");

onMounted(() => {
  store.dispatch("permissions/getUsers");
  store.dispatch("permissions/getRoles");
});

const list: Ref<IUser[]> = computed(() => {
  return store.state.permissions.users;
});

const filteredList = computed(() => {
  if (!searchQuery.value) {
    return list.value.filter((item: IUser) => item.roles?.length);
  }
  return list.value
    .filter((item: IUser) => item.roles?.length)
    .filter((item: IUser) =>
      (item.firstName + item.lastName)
        .toLowerCase()
        .includes(searchQuery.value.toLowerCase())
    );
});

const filteredDropdownList = computed(() => {
  if (!searchDropdownQuery.value) {
    return list.value;
  }
  return list.value.filter(
    (item: IUser) =>
      (item.firstName + item.lastName)
        .toLowerCase()
        .includes(searchDropdownQuery.value.toLowerCase()) ||
      item.email.toLowerCase().includes(searchDropdownQuery.value.toLowerCase())
  );
});

const roles = computed(() => {
  return store.state.permissions.roles;
});

const handleDeleteClick = (id: number) => {
  ElMessageBox.confirm(
    "",
    "Please confirm that you want to delete this user?",
    {
      confirmButtonText: "OK",
      cancelButtonText: "Cancel",
      cancelButtonClass: "cancel-button",
      confirmButtonClass: "confirm-button",
      showClose: false,
    }
  ).then(async () => {
    const formData = new FormData();
    formData.append("roles[]", "");
    store.dispatch("permissions/deleteRoles", id);
  });
};

const onChangeRole = (roles: string[], id: string) => {
  const formData = new FormData();
  roles.forEach((role, index) => {
    formData.append(`roles[${index}]`, role);
  });
  store.dispatch("permissions/updateUser", {
    id,
    field: formData,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "permissions-page__title" }, "Permissions", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          "prefix-icon": _unref(Search),
          modelValue: searchQuery.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
          placeholder: "Search"
        }, null, 8, ["prefix-icon", "modelValue"]),
        _createVNode(_component_el_dropdown, {
          trigger: "click",
          onCommand: _cache[2] || (_cache[2] = ($event: any) => (onChangeRole(roles.value[0], $event)))
        }, {
          dropdown: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_input, {
                "prefix-icon": _unref(Search),
                modelValue: searchDropdownQuery.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchDropdownQuery).value = $event)),
                placeholder: "Name or Email",
                size: "small"
              }, null, 8, ["prefix-icon", "modelValue"])
            ]),
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDropdownList.value, (user) => {
                  return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                    key: user.id,
                    command: user.id
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(user.firstName) + " " + _toDisplayString(user.lastName), 1)
                    ]),
                    _: 2
                  }, 1032, ["command"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "success",
              icon: _unref(Plus)
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("Add Employee", -1)
              ]))]),
              _: 1
            }, 8, ["icon"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_table, {
          data: filteredList.value,
          height: "100%",
          style: {"width":"100%","border-radius":"4px"}
        }, {
          empty: _withCtx(() => [
            _createVNode(_unref(EmptyData), { class: "permissions-page__table-empty" })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "id",
              label: "#",
              width: "70"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.$index + 1), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "firstName",
              label: "Name"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.firstName) + " " + _toDisplayString(scope.row.lastName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "email",
              label: "Email"
            }),
            _createVNode(_component_el_table_column, {
              prop: "roles",
              label: "Role",
              width: "160"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_select, {
                  "model-value": scope.row.roles,
                  multiple: "",
                  class: "m-2",
                  placeholder: "Select",
                  size: "small",
                  onChange: ($event: any) => (onChangeRole($event, scope.row.id))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roles.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item,
                        label: item,
                        value: item
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["model-value", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "",
              width: "86"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "danger",
                  plain: "",
                  onClick: ($event: any) => (handleDeleteClick(scope.row.id))
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("Delete", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ])
    ])
  ]))
}
}

})